<script lang="ts">
  import {
    Column,
    FormLabel,
    Grid,
    RadioTile,
    Row,
    TileGroup,
  } from "carbon-components-svelte";
  import type { IColor } from "src/ts/Interfaces";

  export let selectedCombo: IColor[];

  let combo: IColor[] = [
    { name: "", code: "#000000" },
    { name: "", code: "#ffffff" },
  ];
  if (selectedCombo && selectedCombo.length > 1) {
    combo[0] = selectedCombo[0];
    combo[1] = selectedCombo[1];
  }
  combo[0].name = "";
  combo[1].name = "";
</script>

<Grid noGutter>
  <Row>
    <Column>
      <FormLabel for="font-colour">Font Color</FormLabel>
      <input
        type="color"
        name="font-colour"
        id="font-colour"
        class="bg-colorCombo bx--tile bx--tile--selectable"
        bind:value={combo[0].code}
        on:change={() => {
          selectedCombo[0] = combo[0];
        }}
      />
    </Column>
    <Column>
      <FormLabel for="background-colour">Background Color</FormLabel>
      <input
        type="color"
        name="background-colour"
        id="background-colour"
        class="bg-colorCombo bx--tile bx--tile--selectable"
        bind:value={combo[1].code}
        on:change={() => {
          selectedCombo[1] = combo[1];
        }}
      />
    </Column>
    <Column>
      <TileGroup legend="Preview">
        <RadioTile
          class="bg-colorCombo"
          style={`background-image:linear-gradient(90deg,${combo[1].code},${combo[1].code});color:${combo[0].code}`}
          disabled
        >
          &uhblk;&uhblk;&uhblk;&uhblk;
          <br />
          &uhblk;&uhblk;&uhblk;
        </RadioTile>
      </TileGroup>
    </Column>
  </Row>
</Grid>
